var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"title":"職缺管理","isEmpty":_vm.isEmptyData}},_vm._l((_vm.dataList),function(item,index){return _c('ListJobManageItem',{key:("JobManageItem-" + index),attrs:{"item":item,"details":""},on:{"update":_vm.getOwnerJobs}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }